import { flowRight } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { getPostCover, isExperimentEnabled } from '@wix/communities-blog-client-common';
import { EXPERIMENT_USE_RESOLVED_COVER_IMAGE } from '@wix/communities-blog-experiments';

import { connect } from '../../../common/components/runtime-context';
import Banner from '../../components/banner';
import withTranslate from '../../../common/hoc/with-translate';
import { getLastFeaturedPost, getLastFeaturedPostCategory } from '../../selectors/last-featured-post-selectors';
import styles from './featured-post-banner.scss';
import withMediaHosts from '../../../common/hoc/with-media-hosts';

class FeaturedPostBanner extends React.Component {
  render() {
    const { lastFeaturedPost, lastFeaturedPostCategory, imageHost, videoHost, useResolvedCoverImage, t } = this.props;
    if (!lastFeaturedPost) {
      return null;
    }
    const category = lastFeaturedPostCategory && lastFeaturedPostCategory.label;
    const link = { to: `/${lastFeaturedPost.slug}`, text: t('banner.read-more-label') };
    const { shouldRender, imageMetadata } = getPostCover(lastFeaturedPost, imageHost, videoHost, useResolvedCoverImage);
    const image = shouldRender ? imageMetadata : null;
    return (
      <div className={styles.spacer}>
        <Banner title={lastFeaturedPost.title} category={category} link={link} image={image} />
      </div>
    );
  }
}

FeaturedPostBanner.propTypes = {
  lastFeaturedPost: PropTypes.object,
  lastFeaturedPostCategory: PropTypes.object,
  useResolvedCoverImage: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

const mapRuntimeToProps = (state) => ({
  lastFeaturedPost: getLastFeaturedPost(state),
  lastFeaturedPostCategory: getLastFeaturedPostCategory(state),
  useResolvedCoverImage: isExperimentEnabled(state, EXPERIMENT_USE_RESOLVED_COVER_IMAGE),
});

export default flowRight(connect(mapRuntimeToProps), withTranslate, withMediaHosts)(FeaturedPostBanner);
